const paths = {
  login: "/dev/login",
  mePage: "/dev/me",
  myProjects: "/projects",
  singleProject: "/projects/:projectId",
  myTasks: "/mytasks",
  // projectFormApi: "/new-project",
  projectEquipsApi: "/project-equipments",
  EquipmentsApi: "equipments",
  vendorScreen: "/vendor",
  vendorMrqs: "/vendor-mrqs/:token",
  clientVendors: "/client-vendors-page",
  materialsDB: "/materials-database",
  scm: "/supply-chain-management",
  allstaff: "/allstaff",
  main_pv: "/projects/:id/equipments/main_pv/:equipId",
  main_pv_tabs: "/projects/:id/equipments/main_pv/:equipId/*",

  // admin
  allTasks: "/admin/alltasks",
  allVideosHistory: "/admin/allHistory",
  allUsersTimesheet: "/admin/alluserstasks",
  allTimesheets: "/admin/allTimesheets",
  currentTasks: "/admin/currentTasks",
  dashboard: "/dashboard",
  clients: "admin/clients",

  contactPage: "/home/contact",
  epcmPage: "/home/epcm",
  softwarePage: "/home/software",

  loginPath: "/dev/login",
  demoPath: "/home/demo",
  onBoardingPath: "/home/onboarding",
};

export default paths;
